// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__ipAbg","row":"Carousel_row__JNJgu","text":"Carousel_text__jVXKL","scroll":"Carousel_scroll__TC41k","icon":"Carousel_icon__e3li_"};